import { Injectable } from '@angular/core';
import { CanDeactivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { UserLocalSelectionService } from '../dataServices/user-local-selection-service/user-local-selection.service';


@Injectable({
  providedIn: 'root'
})
export class RegistrationWithCleanupGuard implements CanDeactivate<unknown> {

  private readonly REGISTRATION_FLOW_PATHS = [
    '/registry',
    '/registry/confirmationlink',
    '/registry/confirm',
    '/registry/confirmation',
    '/organisation'
  ];

  constructor(private localSelectionService: UserLocalSelectionService) {}

  canDeactivate(
    component: unknown,
    currentRoute: ActivatedRouteSnapshot,
    currentState: RouterStateSnapshot,
    nextState?: RouterStateSnapshot
  ): boolean {
    
    if (!nextState) {
      return true;
    }

    const nextUrl = nextState.url;

    // If within the paths (Norbert Neukunde) than no clean up
    if (this.isWithinRegistrationFlow(nextUrl)) {
      return true;
    }

    this.localSelectionService.clearSelection('selectedPackage-register');
    
    return true;
  }

  private isWithinRegistrationFlow(url: string): boolean {
    return this.REGISTRATION_FLOW_PATHS.some(path => url.startsWith(path));
  }
}
